"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/TranslationOffDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _selectBlobjectByWrappedKey = require('shared/selectors/blobject/common/selectBlobjectByWrappedKey');
var _selectMyOrgKeyInConvo = require('shared/selectors/conversation/selectMyOrgKeyInConvo');
var _common = require('shared/selectors/org/common');
var _peers = require('shared/selectors/peers');
var _translation = require('shared/selectors/translation');
var _relations = require('shared/selectors/user/relations');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Button = require('web/components/Form/Button/Button');
var _hooks = require('web/services/hooks');

/* The org whose setting turned translation off for this chat: the
 * patient's, or else the one the current user is in the chat through. */
const selectChatOrgKey = (state, conversationKey) => {
  const translation = _translation.selectConversationTranslation.call(void 0, state, conversationKey)
  const patientKey = _nullishCoalesce(_optionalChain([translation, 'optionalAccess', _ => _.PatientKey]), () => ( _optionalChain([translation, 'optionalAccess', _2 => _2.Patients, 'optionalAccess', _3 => _3[0], 'optionalAccess', _4 => _4.PatientKey])))
  const patientOrgKey = patientKey ? _optionalChain([_peers.selectPatientByKey.call(void 0, state, patientKey), 'optionalAccess', _5 => _5.OrgKey]) : undefined
  if (patientOrgKey) return patientOrgKey
  const blobject = _selectBlobjectByWrappedKey.selectBlobjectByWrappedKey.call(void 0, state, conversationKey)
  return blobject ? _selectMyOrgKeyInConvo.selectMyOrgKeyInConvo.call(void 0, state, blobject.Key) : null
}







/* Shown instead of acting when staff use a translation control (Language,
 * Translate on a message) while their org has translation off: "Translation
 * is turned off for <org>. Ask an admin to turn it on." An admin of that org
 * also gets Open settings, to Settings › Organization. */
const TranslationOffDialog = ({ conversationKey, isOpen, onClose }) => {
  const orgKey = _hooks.useAppSelector.call(void 0, state => isOpen ? selectChatOrgKey(state, conversationKey) : null)
  const orgName = _hooks.useAppSelector.call(void 0, state => orgKey ? _optionalChain([_common.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _6 => _6.Name]) : undefined)
  const isAdmin = _hooks.useAppSelector.call(void 0, state => !!orgKey && _relations.selectAmIAdminInOrg.call(void 0, state, orgKey))

  // Focus moves into the dialog, onto its first button.
  const firstButtonRef = _react.useRef(null)
  _react.useEffect.call(void 0, () => {
    if (isOpen) _optionalChain([firstButtonRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.focus, 'call', _9 => _9()])
  }, [isOpen, isAdmin])

  const onOpenSettings = _react.useCallback.call(void 0, () => {
    onClose()
    if (orgKey) _actions2.default.gotoOrgInfoSettings(orgKey)
  }, [onClose, orgKey])

  return (
    _react2.default.createElement(_Modal2.default, { title: "Translation is off"  , size: "xs", isOpen: isOpen, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 57}},  _translation.translationOffForOrgMessage.call(void 0, orgName) )
      , _react2.default.createElement('div', { className: "blm-modal--buttons-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
        ,  isAdmin
          ? (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('button', {
                  ref: firstButtonRef,
                  type: "button",
                  className: _classBuilder2.default.call(void 0, _Button.btnClassName, _Button.secondaryBtnClassName),
                  onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
, "Close"

                )
                , _react2.default.createElement('button', {
                  type: "button",
                  className: _classBuilder2.default.call(void 0, _Button.btnClassName, 'blm-btn--primary'),
                  onClick: onOpenSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
, "Open settings"

                )
              )
            )
          : (
              _react2.default.createElement('button', {
                ref: firstButtonRef,
                type: "button",
                className: _classBuilder2.default.call(void 0, _Button.btnClassName, 'blm-btn--primary'),
                onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
, "OK"

              )
            )
        
      )
    )
  )
}

exports. default = _react.memo.call(void 0, TranslationOffDialog)
